import { SVGProps } from 'react';

export const SocialIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='22'
    height='22'
    viewBox='0 0 22 22'
    fill='none'
    {...props}>
    <path
      d='M7.14271 16.8186L9.87888 18.8513C10.2319 19.1901 11.0263 19.3595 11.5558 19.3595H14.9098C15.9689 19.3595 17.1163 18.5972 17.3811 17.5809C17.5473 16.9427 17.815 16.3143 18.0289 15.6899C18.4273 14.5276 18.8981 13.3681 19.2307 12.1872C19.3802 11.6566 19.4268 11.0695 19.2338 10.5434C18.5334 8.63364 15.8695 9.19586 14.2918 9.19586C13.7622 9.19586 13.321 8.77235 13.4092 8.17952L13.8505 5.46928C14.0271 4.70699 13.4975 3.8601 12.7031 3.60592C11.997 3.35187 11.1143 3.69065 10.7613 4.19875L7.14258 9.36519'
      strokeWidth='1.7'
      strokeMiterlimit='10'
    />
    <path
      d='M2.64062 16.8176V8.51738C2.64062 7.33158 3.17025 6.9082 4.40583 6.9082H5.28851C6.52422 6.9082 7.05371 7.33171 7.05371 8.51738V16.8176C7.05371 18.0034 6.52409 18.4267 5.28851 18.4267H4.40583C3.17012 18.4267 2.64062 18.0032 2.64062 16.8176Z'
      strokeWidth='1.7'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
